import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getWithdrawPoolsSuccess,
  getWithdrawPoolsFailed,
  GET_WITHDRAW_POOLS_START,
} from '../../actions/pools'

/**
 * get withdraw pools api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getWithdrawPoolsApi = (props) => {
  var uri = `/admin/treasury/withdraw`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetWithdrawPools(action) {
  try {
    const response = yield call(getWithdrawPoolsApi, action?.payload)
      yield put(getWithdrawPoolsSuccess(response))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess(response)
      }
  } catch (error) {
    yield put(getWithdrawPoolsFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get withdraw pools
 */
export default function* watchGetWithdrawPools() {
  yield takeLatest(GET_WITHDRAW_POOLS_START, doGetWithdrawPools)
}
